import React from 'react';

import MenuItem from './MenuItem';

const SideNav = ({translate, menu, user_name, profession}) => (
	<ul id="mobile-demo" className="menu side-nav">
		<li className="mobile-profile">
			<div className="profile-inner">
				<div className="pp-container">
					<h3>{translate(user_name)}</h3>
					<h5>{translate(profession)}</h5>
				</div>
			</div>
		</li>
		{
			menu.map((item, index) => (
				<MenuItem key={item.label} {...item} translate={translate} active={index === 0}/>
			))
		}
	</ul>
);

export default SideNav;



// WEBPACK FOOTER //
// ./src/components/elements/SideNav.js